import React from "react";
import PropTypes from "prop-types";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";

import { media } from "utils/style";
import { ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import Modal from "common-components/Modal/Modal";
import Button from "common-components/Buttons";

const DeleteModal = ({
  modalContent,
  handleDelete,
  handleCancel,
  ...props
}) => {
  return (
    <Modal contentLabel="delete modal">
   <ModalTitle>

        <H2>{modalContent.section_title}</H2>
        </ModalTitle>
      <ModalBody>
        {convertStringToElements(modalContent.section_description)} </ModalBody>
        <ModalFooter
        buttonData={{
          primary: {
            width: '100%',
            children: modalContent.buttons[0].text,
            onClick: () => handleDelete()
          },
          close: {
            width: '100%',
            children: modalContent.buttons[1].text,
            onClick: () => handleCancel(),
          },
        }}
      />

        {/* <ButtonContainer>
          <Button
            background={modalContent.buttons[0].type}
            onClick={handleDelete}
          >
            {modalContent.buttons[0].text}
          </Button>
          <Button
            background={modalContent.buttons[1].type}
            onClick={handleCancel}
          >
            {modalContent.buttons[1].text}
          </Button>
        </ButtonContainer>
      </Div> */}
    </Modal>
  );
};

export default DeleteModal;

DeleteModal.propTypes = {
  modalContent: PropTypes.object.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired
};

const Div = styled.div`
  max-width: 438px;

  p {
    margin: 15px 0;
  }
`;

const H2 = styled.h2`
 margin-bottom: 24px;

 ${media.mobile`
  margin-right: 20px;
    font-size: 26px;
    line-height: 24px;
 `}
`
const ButtonContainer = styled.div`
  display: flex;
  marginTop: "56px";
  ${media.mobile`
   flex-direction: column;
  `}
`;